import React from 'react'
import PropTypes from 'prop-types'
import PopperMUI from '@material-ui/core/Popper'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import classNames from 'classnames'

const Popper = ({ trigger, onClick, placement, children, className, popperClassName, testId }) => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const id = Math.floor(Math.random() * Math.floor(1000))
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  React.useEffect(() => {
    if (onClick) onClick(open)
  }, [open])

  return (
    <React.Fragment>
      <div
        // aria-describedby={`detail-${id}`}
        onClick={handleClick}
        className="popper_box--trigger"
      >
        {trigger}
      </div>
      <PopperMUI
        data-testid={testId}
        className={classNames('popper-tooltip', popperClassName)}
        anchorEl={anchorEl}
        disablePortal={false}
        id={`detail-${id}`}
        open={open}
        placement={placement}
        modifiers={{
          flip: {
            enabled: true,
          },
          preventOverflow: {
            enabled: false,
            boundariesElement: false,
          },
          arrow: {
            enabled: true,
            element: anchorEl,
          },
        }}
      >
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <div className={classNames('popper--atom-box', placement, className)}>{children}</div>
        </ClickAwayListener>
      </PopperMUI>
    </React.Fragment>
  )
}

Popper.propTypes = {
  trigger: PropTypes.node,
  testId: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  placement: PropTypes.string,
  className: PropTypes.string,
  popperClassName: PropTypes.string,
}

Popper.defaultProps = {
  placement: 'right',
}

export default React.memo(Popper)
